module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "gaming-background-mobile.37e0cf88.jpg";